import React from 'react';
import './Heading.css';



const Heading = ({ title, sideHeading = false, linear = false }) => {

  return (
    <div className={`heading ${sideHeading ? 'sideheading' : ''} ${linear ? 'linear-bg' : ''}`}>

      <h2>{title}</h2> {/* Display the title */}

    </div>
  );
};

export default Heading;